import parse from 'date-fns/parse';

/**
 * SL says in the future when we upgrade date-fns beyond v1.30
 * we can replace this with date-fns/formatISO from v2.
 *
 * @param {Mixed} date date string / object
 * @returns {String} formatted date string
 */
const formatISO = date => parse(date).toISOString();

export default formatISO;
